const MESSAGES = {
  saveSuccessfully: 'บันทึกข้อมูลสำเร็จ',
  saveFailure: 'เกิดความผิดพลาด ไม่สามารถบันทึกข้อมูลได้',
  deleteSuccessfully: 'ลบข้อมูลสำเร็จ',
  deleteFailure: 'เกิดความผิดพลาด ลบข้อมูลไม่สำเร็จ',
};

export default MESSAGES;
